export default () => ({
  companies: null,
})
